import React from "react";
import { MasterConfigs } from "../../../../interfaces/entity";
import MasterComponent from "../../../../components/Forms";
import { Space, Tag, Typography } from "antd";
const { Text } = Typography;

const LoginHistory = () => {
    const loginConfig: MasterConfigs = {
        api: () => "/login-history?loginType=login",
        modalTitle: () => "Login Success",
        getColumns: () => {
            return [
                {
                    title: "Employee",
                    dataIndex: "userId",
                    key: "userId",
                    width: 200,
                    render: (text, records) => <Space direction="vertical" size={[0, 0]}>
                        <Text>{text?.firstName} {text?.lastName}</Text>
                        <Text type="secondary">{text?.workEmail}</Text>
                    </Space>,
                },
                {
                    title: "IP Address",
                    dataIndex: "ipAddress",
                    key: "ipAddress",
                    align: "center",
                    width: 130,
                },
                {
                    title: "Location",
                    dataIndex: "formatted_address",
                    key: "formatted_address",
                },
                {
                    title: "Latitued",
                    dataIndex: "latitude",
                    align: "center",
                    key: "latitude",
                    width: 110,
                }, {
                    title: "Longitude",
                    dataIndex: "longitude",
                    key: "longitude",
                    align: "center",
                    width: 110,
                },
                {
                    title: "Platform",
                    dataIndex: "platform",
                    key: "platform",
                    align: "center",
                    width: 100,
                },
                {
                    title: "Login Time",
                    dataIndex: "createdAt",
                    key: "createdAt",
                    align: "center",
                    width: 150,
                    render: (text) => new Date(text).toLocaleString(),
                },
                {
                    title: "Status",
                    dataIndex: "loginStatus",
                    key: "loginStatus",
                    align: "center",
                    width: 100,
                    render: (text) => text === "failed" ? <Tag color="red" bordered={false}>Failed</Tag> : <Tag color="green" bordered={false}>Success</Tag>,
                },
                {
                    title: "Reason",
                    dataIndex: "loginFailedReason",
                    key: "loginFailedReason",
                    width: 300,
                    colSpan: 2,
                }
            ];
        }
    }

    return (
        <MasterComponent config={loginConfig} />
    );
}

export default LoginHistory;